import styled from "styled-components";
import { GenericSvg } from "../assets/svgs/GenericSVG";
import { InfoText } from "../components/texts/InfoText";
import { colors } from "../styles/colors";

export const ErrorOverlay = () => {
  return (
    <OuterContainer>
      <Container>
        <GenericSvg
          name="FailureIcon"
          primaryColor={colors.primary}
          size={50}
        />
        <InfoText
          headline={"Seite nicht gefunden"}
          text={[
            "Beim Laden der Seite ist etwas schief gelaufen. Bitte entschuldige und versuche es erneut.",
          ]}
        />
      </Container>
    </OuterContainer>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  max-width: 640px;
  gap: 20px;
  padding: 20px;
`;

const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;
